<!--  -->
<template>
    <div class="MainTemp">
        <div class="content">
            <div class="imgbox">
                <div>
                    <img :src="imgData.img" alt="">
                </div>
               <ScrollBar/>
            </div>
            <div class="boxcontents">
                <template v-for="(item, index) in infoList">
                    <h3>{{ item.title }}</h3>
                    <template v-for="second in item.content">
                        <h5>{{ second.title }}</h5>
                        <ul>
                            <li v-for="third in second.size " class="liinfo">{{ third }}</li>
                        </ul>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainTemp",
    components: {},
    props: ['infoList', 'imgData'],
    data() {
        return {

        };
    },
    methods: {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.content {
    background-color: white;
    width: 100%;
    padding-bottom: 100px;
    position: relative;

    .imgbox {
        width: 100%;

        img {
            width: 100%;
            vertical-align: bottom;
        }
    }

}



ul li {
    list-style: disc outside none;
}

li {
    margin-left: 20px;
}

.companyimg {
    width: 100%;
    vertical-align: bottom;
}

.boxcontents {
    position: relative;
    z-index: 1;
    padding: 40px 300px;
    color: $newsTitle;
    line-height: 2;
    margin-bottom: 40px;
    font-size: 15px;

    p {
        margin-bottom: 20px;
    }
}

.boxcontents:last-child {
    margin-bottom: 0;
}

h3 {
    font-size: 40px;
    font-weight: bold;
    color: $newsTitle;
    margin-bottom: 40px;
}

h5 {
    font-size: 24px;
    font-weight: bold;
    margin: 20px 0;
}

.liinfo {
    margin-bottom: 20px;
}
</style>